/**
 * flt_tagmanager — main entry point.
 *
 * CMP (Consent Management Platform) + conditional pixel injection
 * + focus trap + event queue.
 * CSS is provided by standalone theme files (themes/*.css).
 */

import { initConsentManager } from './organisms/consent-manager';

document.addEventListener('DOMContentLoaded', () => {
  initConsentManager();
});
